import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './in-place-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
let $ = require('jquery');

@Component({
  selector: 'in-place-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./in-place-restore.scss')],
  template: require('./in-place-restore.html')
})

export class InPlaceRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Input('selectedRestore') selectedRestore;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private RESTORE_RADIO_OPTIONS = {"ENTIRE_VAPP":"entireVapp", "SPECIFIC_VMS":"specificVms"};
  private restoreRadioSelected = this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP;
  private isVmListVisible: boolean = false;
  private isVMsChecked: boolean = true;
  private selectedVMs: Array<Object> = [];
  private vAppName = "";
  private vdcName = "";
  private isRequestPending: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    this.runInPlaceRestore();
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  onRestoreRadiosChanged(value) {
    this.restoreRadioSelected = value;
    switch(value) {
      case this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP:
        this.isVmListVisible = false;
        this.isVMsChecked = true;
        this.selectedVMs = [];
        break;
      case this.RESTORE_RADIO_OPTIONS.SPECIFIC_VMS:
        this.isVmListVisible = true;
        this.isVMsChecked = false;
        break;
      default :
        this.isVmListVisible = false;
    }
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedVDC && this.selectedVDC.name && this.selectedObject && this.selectedObject.name) {
        this.vAppName = this.selectedObject.name;
        this.vdcName = this.selectedVDC.name;
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  onVMSelection(vm, event) {
    if(vm && event && event.target) {
      if(event.target.checked && this.selectedVMs.indexOf(vm) === -1) {
        this.selectedVMs.push(vm);
      }
      if(!event.target.checked && this.selectedVMs.indexOf(vm) !== -1) {
        this.selectedVMs.splice(this.selectedVMs.indexOf(vm), 1);
      }
      //To fix bug 1755235
      if(this.selectedVMs.length === 0)
        this.isVMsChecked = false;
      else
        this.isVMsChecked = true;
    }
  }

  getIdArrayFromSelectedVMs() {
    let returnArray = [];
    this.selectedVMs.forEach((vm) => {
      if(vm['id']) returnArray.push(vm['id']);
    });
    return returnArray;
  }

  runInPlaceRestore() {
    if(this.selectedVDC && this.selectedVDC.id && this.selectedVDC.id !== ''
      && this.selectedObject && this.selectedObject.id && this.selectedObject.id !== ''
      && this.selectedRestore && this.selectedRestore.id && this.selectedRestore.id !== '') {

      let inPlaceRestorePayload = {};
      let vms = this.getIdArrayFromSelectedVMs();
      if ( this.restoreRadioSelected === this.RESTORE_RADIO_OPTIONS.SPECIFIC_VMS && vms.length > 0 ) {
          inPlaceRestorePayload = {"restorePointId": this.selectedRestore.id,"entityType":"VAPP_RESTORE","vmEntityIds":vms};
      }else{
          inPlaceRestorePayload = {"restorePointId": this.selectedRestore.id,"entityType":"VAPP_RESTORE"};
      }

      this.isRequestPending = true;
      this.subscribeHandler = this.service.runInPlaceRestore(this.selectedVDC.id, this.selectedObject.id, inPlaceRestorePayload)
        .subscribe(
          res => {
            this.reset();
            this.closeSelf();
          },
          error => this.logError(error, 'in place restore'),
          () => this.logOperationCompleted('in place restore')
        );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.restoreRadioSelected = this.RESTORE_RADIO_OPTIONS.ENTIRE_VAPP;
    this.isVmListVisible = false;
    this.selectedVMs = [];
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
    this.isRequestPending = false;
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.isRequestPending = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/in-place-restore/in-place-restore.component.ts